import {useSelector} from "react-redux";
import Paginator from '../../../components/Paginator'

export default function FocusItemPaginator({onPageClicked}) {
 const {
    loading,
    error,
    page,
    totalPages,
    init,
  } = useSelector((state) => state.focusItem)



  // const dispatch = useDispatch();

  // const onPagesClick = (page) => {
  //   dispatch(tryLoadUsers({page}));
  // };
  //
  // const onPageClick = (page) => {
  //   if (init) {
  //     // let currentPage = data.selected + 1
  //     dispatch(setIntialPage(page))
  //
  //     const url = new URL(window.location);
  //     url.searchParams.set('page', page)
  //     setUrl(url)
  //     fetchFocusItemListAction()
  //
  //   }
  // }


  return (
    <>
      {!error &&
      <Paginator currentPage={page} totalPages={totalPages} onClick={onPageClicked}
               loading={!init || loading}/>}
    </>
  );
}
